import { getOfficialStandardText } from "../../data/defensieStandards";

const luchtmobieleBrigadeConfig = {
  meta: {
    title: "Voorbereiding Luchtmobiele Brigade | Mission Movement",
    description:
      "Alles over voorbereiding richting 11 Luchtmobiele Brigade: keuring, kennismakingsdagen, fysieke eisen, marsen met bepakking, mentale weerbaarheid, belastbaarheid en gerichte training via Mission Movement.",
    ogTitle: "Voorbereiding Luchtmobiele Brigade | Mission Movement",
    ogDescription:
      "Alles over voorbereiding richting 11 Luchtmobiele Brigade: keuring, kennismakingsdagen, fysieke eisen, marsen met bepakking, mentale weerbaarheid, belastbaarheid en gerichte training via Mission Movement.",
    ogImage: "https://missionmovement.nl/img/thestory.png",
    ogUrl: "https://missionmovement.nl/units/luchtmobiel",
    canonical: "https://missionmovement.nl/units/luchtmobiel",
  },
  hero: {
    eyebrow: "Luchtmobiele Brigade",
    imageSrc: "/img/eenheden/lmb_wide.jpg",
    imageAlt: "Luchtmobiele Brigade",
    objectPosition: "center 80%",
    overlayClass: "mm-heroOverlay",
    title: "11 Luchtmobiele Brigade",
    subtitle:
      "Voor kandidaten die serieus richting 11 Luchtmobiele Brigade willen werken: van keuring en kennismakingsdagen tot opleiding, marsen met bepakking en belastbaarheid.",
  },
  subNav: {
    variant: "dark",
    scrollable: false,
  },
  intro: {
    emblemSrc: "/img/eenheden/lmb_embleem1.png",
    emblemAlt: "Luchtmobiele Embleem",
    heading: "Wat is 11 Luchtmobiele Brigade?",
    body:
      "Na de val van de Berlijnse Muur in 1989 veranderde de wereldwijde veiligheidssituatie ingrijpend. Nederland zag de noodzaak voor een snel inzetbare eenheid die wereldwijd flexibel kon opereren binnen het volledige geweldsspectrum. Dit leidde in 1992 tot de oprichting van 11 Luchtmobiele Brigade. Deze brigade is een hoogwaardige infanterie-eenheid van de Koninklijke Landmacht, gespecialiseerd in snelle inzet via helikopters of transportvliegtuigen. De nadruk ligt op snelheid, wendbaarheid en het opereren in kleine, zelfstandige teams - vaak diep achter vijandelijke linies.\n\nAls luchtmobiel militair word je opgeleid om langdurig te presteren onder fysieke en mentale druk. Je traint intensief op uithoudingsvermogen, oriëntatievermogen en samenwerking onder stress. De missies zijn uiteenlopend - van gevechtsoperaties tot humanitaire inzet - maar vragen altijd een hoog niveau van discipline, fitheid en paraatheid.\n\nVoor kandidaten betekent dit dat voorbereiding verder moet gaan dan alleen conditie opbouwen. Je moet werken aan kracht, uithoudingsvermogen, herstel, marsen met bepakking, samenwerking onder druk en mentale weerbaarheid. Niet alleen om aan de minimale eisen te voldoen, maar om sterker en met meer marge aan de opleiding te beginnen.",
    accentBorder: "border-mmAccent",
  },
  accordion: {
    heading: null,
    items: [
      {
        title: "Ontstaan & Missie",
        image: "/img/lmb/ontstaan.jpeg",
        objectPosition: "bottom",
        content:
          "De 11 Luchtmobiele Brigade is een snel inzetbare infanterie-eenheid van de Koninklijke Landmacht. De eenheid werd opgericht in 1992 en is gespecialiseerd in luchtverplaatsbare operaties. Militairen van deze brigade worden via helikopters of vliegtuigen direct ingezet in gebieden waar snelheid en mobiliteit cruciaal zijn. De brigade vormt samen met het Korps Mariniers de Nederlandse bijdrage aan de snelle interventiemacht van de NAVO.",
      },
      {
        title: "Inzet & Specialisaties",
        image: "/img/lmb/inzet.jpg",
        objectPosition: "center",
        content:
          "De Luchtmobiele Brigade wordt wereldwijd ingezet voor missies waarbij snelheid en flexibiliteit essentieel zijn, zoals humanitaire operaties, evacuaties en gevechtsinzet. De eenheid opereert vaak in kleine groepen en is getraind op snel reageren in complexe omstandigheden. Luchtmobiel optreden vraagt om fysieke weerbaarheid, mentale veerkracht en nauwe samenwerking.",
      },
      {
        title: "Structuur & Locaties",
        image: "/img/lmb/locatie.jpg",
        objectPosition: "center",
        content:
          "De 11 Luchtmobiele Brigade is gestationeerd op twee hoofdlocaties: de Oranjekazerne in Schaarsbergen en de Johan Willem Frisokazerne in Assen. De brigade bestaat uit infanteriecompagnieën, ondersteunende gevechtseenheden en logistieke afdelingen. Voor luchtverplaatsing werkt de eenheid nauw samen met de Koninklijke Luchtmacht, met inzet van transporthelikopters en vliegtuigen.",
      },
      {
        title: "Keuring & Selectiemomenten",
        image: "/img/lmb/keuring.webp",
        objectPosition: "center",
        content:
          "Het functiecluster voor de aanstellingskeuring volgt uit de vacature waarop je solliciteert. De Kennismakingsdagen Luchtmobiel voor soldaat- en korporaalfuncties vormen een afzonderlijk selectiemoment. Raadpleeg je actuele vacature en uitnodiging voor de instroomroute, opleidingsinformatie en onderdelen die voor jou gelden.",

      },
      {
        title: "Fysieke onderdelen Kennismakingsdagen Luchtmobiel",
        image: "/img/lmb/fysiek.webp",
        objectPosition: "center",
        content: getOfficialStandardText("luchtmobiel"),

      },
      {
        title: "Carrièrepad & Doorstroom",
        image: "/img/lmb/pathfinders.jpg",
        objectPosition: "top",
        content:
          "Na het afronden van de opleiding start je als luchtmobiele infanterist. Vanuit deze basisrol kun je doorgroeien naar leidinggevende functies of deelnemen aan aanvullende trainingen en cursussen. Doorstroom naar andere onderdelen binnen Defensie is ook mogelijk, zoals het Korps Commandotroepen (KCT), de Koninklijke Luchtmacht of internationale eenheden. Specialisaties en doorgroei worden verder toegelicht onderaan deze pagina.",
      },
      {
        title: "Voorbereiding & Belastbaarheid",
        image: "/img/lmb/barret.jpeg",
        objectPosition: "top",
        content:
          "Voor je voorbereiding kun je werken aan conditie, krachtuithouding, herstel, marsen en samenwerken. Bouw de belasting op vanuit je huidige niveau en pas je training aan op herstel en uitvoering. Dit zijn trainingsgebieden; een goede voorbereiding geeft geen garantie op selectie of het afronden van een opleiding.",
      },
    ],
  },
  contentBlocks: [
    {
      heading: "Specialisaties binnen de Luchtmobiele brigade",
      items: [
        {
          title: "Specialisaties & Doorgroeimogelijkheden",
          content:
            "Binnen 11 Luchtmobiele Brigade zijn er volop mogelijkheden om je verder te specialiseren of door te groeien naar zwaardere rollen. Na het behalen van je rode baret begin je als luchtmobiel infanterist, maar afhankelijk van je inzet, capaciteiten en ambities kun je doorgroeien naar o.a.:\n\n- Pathfinder: Vooruitsturende eenheden die landing zones verkennen, markeren en tactisch voorbereiden voor helikopterinzet.\n- Sniper of Verkenner: Gericht op stealth, observatie en precisieoptreden in kleine zelfstandige teams.\n- Medic: Gevechtsverpleger die zelfstandig medische hulp verleent in het veld.\n- JTAC: Joint Terminal Attack Controller, specialist in het coördineren van luchtsteun vanuit de grond.\n- Air Assault Instructeur: Training geven in het tactisch inzetten van eenheden via helikopters.\n\nDaarnaast is er ruimte voor:\n\n- Internationale samenwerking: Via uitzendingen, trainingen of de Division Schnelle Kräfte (DSK) werk je intensief samen met buitenlandse eenheden.\n- Overstap naar special forces: Ervaren luchtmobiele militairen kunnen geselecteerd worden voor de opleiding tot commando (KCT), mits ze voldoen aan de vereisten. De passende instroomroute en voorwaarden moeten bij Defensie worden gecontroleerd.\n\nDeze doorgroeimogelijkheden vragen discipline, betrouwbaarheid onder druk en de wil om jezelf te blijven ontwikkelen op fysiek, mentaal en tactisch vlak.",
        },
      ],
    },
  ],
  cta: {
    eyebrow: "Luchtmobiel voorbereiding",
    heading: "Wil je serieus richting 11 Luchtmobiele Brigade?",
    body:
      "Iedere richting vraagt een andere combinatie van kracht, conditie, marsvermogen, belastbaarheid, herstel en mentale weerbaarheid. Daarom werk je binnen Mission Movement vanuit een vaste 12-weekse structuur, met accenten die passen bij jouw doel. Je traint niet alleen voor de test. Je bouwt aan het lichaam dat de opleiding en het werk daarna moet kunnen dragen.",
    buttonText: "Bekijk het 12-weekse programma",
    buttonTo: "/program",
  },
  forWho: {
    heading: "Voor wie is dit geschikt?",
    bullets: [
      "Je wilt luchtmobiel militair worden en zoekt structuur in je voorbereiding richting keuring, kennismakingsdagen en opleiding.",
      "Je traint al, maar weet niet zeker of je voorbereiding aansluit op de fysieke eisen van Defensie.",
      "Je wilt sterker worden in kracht, uithoudingsvermogen, marsen met bepakking en herstelvermogen.",
      "Je wilt niet alleen de minimale norm halen, maar met meer marge aan je traject beginnen.",
      "Je zoekt een duidelijke opbouw waarin elke training een functie heeft binnen de grotere voorbereiding.",
      "Je wilt serieus werken aan discipline, samenwerking, belastbaarheid en mentale weerbaarheid.",
    ],
  },
  route: {
    heading: "Jouw route naar 11 Luchtmobiele Brigade",
    steps: [
      "Oriëntatie: begrijpen wat 11 Luchtmobiele Brigade vraagt",
      "Start voorbereiding: kracht, conditie, marsvermogen en belastbaarheid opbouwen",
      "Aanmelding en selectieprocedure bij Defensie",
      "Keuringen en fysieke testmomenten",
      "Start van de opleiding die bij jouw functie en instroomroute hoort",
      "Opleiding afronden en doorgroeien als luchtmobiel militair",
    ],
  },
  faq: {
    heading: "Veelgestelde Vragen",
    items: [
      {
        title: "Welke fysieke onderdelen noemt Defensie voor de Kennismakingsdagen Luchtmobiel?",
        content: getOfficialStandardText("luchtmobiel"),
      },
      {
        title: "Is luchtmobiel net zo zwaar als het KCT?",
        content:
          "Het is een andere route. Het Korps Commandotroepen richt zich op Special Operations Forces, terwijl 11 Luchtmobiele Brigade een fysiek en mentaal veeleisende infanterieroute is. Luchtmobiel vraagt snelheid, mobiliteit, teamwork, marsen met bepakking, veldvaardigheden en functioneren onder druk. Het is geen lichtere keuze, maar een ander soort belasting.",
      },
      {
        title: "Is dit programma ook geschikt voor vrouwen?",
        content:
          "Ja. De voorbereiding is bedoeld voor iedere serieuze kandidaat die richting 11 Luchtmobiele Brigade wil werken. De principes blijven hetzelfde: kracht, uithoudingsvermogen, herstel, discipline, belastbaarheid en mentale weerbaarheid. De eisen zijn hoog en vragen om eerlijke, gerichte voorbereiding: consistent trainen, eerlijk schalen en pijnsignalen serieus nemen.",
      },
      {
        title: "Hoe combineer ik training met werk of school?",
        content:
          "Dat kan, maar het vraagt planning, consistentie en realistisch omgaan met je totale belasting. De training kan rond school of werk worden opgebouwd, zolang je eerlijk kijkt naar herstel, beschikbare tijd en prioriteiten. Luchtmobiel worden vraagt discipline en structurele inzet.",
      },
      {
        title: "Wat als ik twijfel of ik geschikt ben?",
        content:
          "Twijfel is normaal. Een gestructureerde voorbereiding helpt je duidelijk krijgen waar je nu staat, waar je zwakke punten zitten en of deze route echt bij je past. Je werkt aan fysieke eisen, marsen met bepakking, herstel, samenwerking en mentale weerbaarheid voordat je het officiële traject instapt. Bij terugkerende pijn, eerdere zware blessures of twijfel over je belastbaarheid is persoonlijk advies verstandiger dan zelfstandig doortrainen.",
      },
      {
        title: "Ik sport al, waarom zou ik dit nodig hebben?",
        content:
          "Algemene fitheid is niet hetzelfde als voorbereiding op Luchtmobiel. Je krijgt te maken met marsen met bepakking, herstel onder vermoeidheid, herhaalde trainingsdagen, teamwork, hiërarchie, veldomstandigheden en progressieve belasting. Gerichte voorbereiding helpt je die belasting stapsgewijs opbouwen.",
      },
      {
        title: "Hoe bereid je je voor op de luchtmobiele opleiding?",
        content:
          "Voor je trainingsvoorbereiding kun je werken aan kracht, uithoudingsvermogen, marsen met bepakking, herstel en samenwerken. Dit is algemene voorbereidingscontext, geen beschrijving van het actuele opleidingsprogramma of extra selectie-eisen. De opleidingsnaam, duur en volgorde van onderdelen vind je bij Defensie voor jouw functie en instroomroute.",
      },
    ],
  },
  stickyMobileCta: {
    enabled: true,
    delayMs: 20000,
    label: "Klaar om gericht te trainen?",
    buttonText: "Bekijk het 12-weekse programma",
    buttonTo: "/program",
  },
};

export default luchtmobieleBrigadeConfig;
